import { render, staticRenderFns } from "./ThreatIndicators.vue?vue&type=template&id=66ae1140"
import script from "./ThreatIndicators.vue?vue&type=script&lang=js"
export * from "./ThreatIndicators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports